<template>
  <span class="view-reading-title" :class="{ 'is-article-title': article }">
    <span v-for="(part, index) in parts" :key="index" :class="index ? 'reading-subtitle' : 'reading-title'">{{ part }}</span>
  </span>
</template>

<script>
import { exhibitionTitleParts } from '../../utils/exhibitionTypography';

export default {
  props: {
    text: { type: String, default: '' },
    article: { type: Boolean, default: false },
  },
  computed: {
    parts() { return exhibitionTitleParts(this.text); },
  },
};
</script>

<style scoped>
.view-reading-title { display: block; overflow-wrap: anywhere; }
.reading-title, .reading-subtitle { display: block; text-wrap: pretty; }
.reading-subtitle {
  margin-top: .45em;
  color: var(--reading-subtitle-color, var(--site-text-secondary));
  font-size: var(--reading-subtitle-size, max(16px, .72em));
  font-weight: 400;
  line-height: 1.45;
  letter-spacing: 0;
}
.is-article-title .reading-title { text-wrap: balance; }
.is-article-title .reading-subtitle {
  margin-top: .55em;
  color: var(--view-muted, var(--site-text-secondary));
  font-size: max(18px, .56em);
}
</style>
